import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWallet2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconWallet2"><Path fillRule="evenodd" clipRule="evenodd" d="M4.5 4C3.11929 4 2 5.11929 2 6.5V17.5C2 18.8807 3.11929 20 4.5 20H19.5C20.8807 20 22 18.8807 22 17.5V6.5C22 5.11929 20.8807 4 19.5 4H4.5ZM5 6C4.44772 6 4 6.44772 4 7V10H6.96447C7.62751 10 8.26339 10.2634 8.73223 10.7322L9.26777 11.2678C9.73661 11.7366 10.3725 12 11.0355 12H12.9645C13.6275 12 14.2634 11.7366 14.7322 11.2678L15.2678 10.7322C15.7366 10.2634 16.3725 10 17.0355 10H20V7C20 6.44772 19.5523 6 19 6H5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWallet2;
